import { createContext, useContext } from "react";

import workspaceService from "../../../clientServices/workspaceSvc";

type WorkspaceService = typeof workspaceService;

const WorkspaceServiceContext = createContext<WorkspaceService>(workspaceService);

export const WorkspaceServiceProvider = WorkspaceServiceContext.Provider;

export function useWorkspaceService() {
    return useContext(WorkspaceServiceContext);
}
